import axios from "axios";
import config from "./config.js";

// Axios örneği oluşturuyoruz
const api = axios.create({
  baseURL: config.apiUrl, // API adresi (config.js içinde tanımlı)
});

// Her istekten önce token ekleyen interceptor
api.interceptors.request.use(
  (request) => {
    const token = sessionStorage.getItem("token"); // veya localStorage.getItem('token')
    if (token) {
      request.headers.Authorization = `Bearer ${token}`;
    }
    return request;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default api;
